<script setup>
import { useI18n } from 'vue-i18n';
import FontAwesomeRender from '@/components/common/utils/FontAwesomeRender.vue';
import LocalStorage from '@/controller/LocalStorage.js';
import YBtn from '../form/YBtn/YBtn.vue';
import { onMounted, ref, computed } from 'vue';
import MazSwitch from 'maz-ui/components/MazSwitch';

import MazDropdown from 'maz-ui/components/MazDropdown';
const { t } = useI18n();
const props = defineProps({
    columns: Array,
    table: String,
    items: Object,
});

const totalHeight = computed(() => {
    return (Array.isArray(props.items) ? props.items.length * 50 : 0) + 'px';
});

const storedColumns = ref('');
const userColor = ref(LocalStorage.getColor());
const emit = defineEmits(["columnToggled"]);
onMounted(() => {
    var storageColumns = localStorage.getItem('columns_'+props.table);
    if (storageColumns) {
        storageColumns = JSON.parse(storageColumns);
    }
    storedColumns.value = props.columns
        .filter(column => column.name !== 'status-mobile')
        .map(column => {
            var label = undefined;
            if(storageColumns){
                const storedColumn = storageColumns.find(storedColumn => storedColumn.name === column.name);
                if(storedColumn){
                    label = storedColumn.text;
                }
            }
            return {name: column.name, visible: column.visible, configurable: column.configurable, label: label ?? column.text}
        })
        .filter(column => column.configurable);
});
function columnVisibilityChanged(columnName, isVisible) {
    const column = storedColumns.value.find(column => column.name === columnName);
    if (column) column.visible = isVisible;
    localStorage.setItem('columns_'+props.table, JSON.stringify(storedColumns.value));
    emit('columnToggled');
}
</script>

<template>
    <div class="column-toggle">
        <div class="user-dropdown desktop" id="userDropdown">
        <MazDropdown trigger="hover" size="xs" position="bottom right" no-chevron color="transparent">
          <template #default>
            <div class="user-icon-wrapper">
              <FontAwesomeRender
                    activityIconClass="fas"
                    activityIconName="fa-ellipsis-vertical">
                </FontAwesomeRender>
            </div>
          </template>
                    <template #dropdown>
                        <div class="user-dropdown-body" >
                                <div class="user-dropdown-scroll" :class="{'little-height': parseInt(totalHeight) < 200}">
                                        <li v-for="column in storedColumns" v-if="storedColumns.length > 1">
                        <div v-if="column.configurable">
                            <MazSwitch
                                v-model="column.visible"
                                color="primary"
                                @change="columnVisibilityChanged(column.name, column.visible)"
                                :id="column.name"
                            >
                            {{ column.label }}
                            </MazSwitch>                            
                        </div>
                    </li>
                </div>
            </div>
          </template>
        </MazDropdown>
      </div>
    </div>
</template>

<style lang="scss" scoped>
::v-deep(.maz-dropdown:hover) {
  background-color: inherit !important;
}
    .column-toggle{
        .form-check-input:checked {
            background-color: v-bind(userColor) !important;
            border-color: #CBD5E1 !important;
        }
        button, button:focus, button:active{
            border: none;  
        }
        .dropdown-menu{
            min-width: 260px;
            border-radius: 25px;
            padding: 1.5rem;
            border: 1px solid #E4E7EC;
            
            li{
                margin-bottom: 5px;
            };
        }
        .btn-user:focus{
            border: none;
        }
    }
    .column-toggle li {
        list-style: none;
        
    }
    ::v-deep(.m-btn.--is-button.--transparent:not(:disabled):hover) {
        background-color: transparent !important;
    }
    ::v-deep(.m-dropdown .menu ) {
        padding: .2rem;
    }
    .actions{
        display: flex;
        justify-content: flex-end;
        font-size: 11px;
        .mark-all-read{
            margin-bottom: 0.5rem;
        }
        .mark-all-read:hover{
            cursor: pointer;
            text-decoration: underline;
        }
        .light-grey{
            color: #cbd5e1;
        }
    }
    .notifications-list{
        flex-grow: 1;
        margin-top: 1rem;
    }
    .user-dropdown-actions{
        display: flex;
        flex-direction: column;
        margin-top: 1rem;
        justify-content: center;
        align-items: center;
        gap: 1.5rem;
        a{
            text-decoration: none;
            color: #153440;
            font: normal normal normal 16px/19px 'CircularStd-Bold';
        }
    }
    .undername-separator{
        margin: 0;
        margin-top: -5px;
        margin-bottom: 5px;
        color: #a8b0ba;
    }


    .user-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px; 
  }
  
  .user-dropdown-body {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    min-height: 120px;
  }

  .little-height{
    min-height: 90px !important;
    max-height: v-bind(totalHeight);
    padding-bottom: 0.1rem;
  }

  .user-dropdown-body {
    min-height: 120px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    min-height: 120px;
}

.user-dropdown-scroll {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow-y: auto;
    scrollbar-gutter: stable both-edges;
}

</style>